import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'proj-onboard',
});

export const projectListRouteRef = createRouteRef({
  id: 'proj-onboard-projects',
});

export const projectDetailRouteRef = createRouteRef({
  id: 'proj-onboard-project-detail',
});
